<template>
  <v-bottom-navigation
    color="green"
    fixed
    active-class="active-btn"
    elevation="2"
  >
    <v-btn
      v-if="!$store.state.teacherAccess"
      to="/"
    >
      <span>{{ $t('dashboard') }}</span>

      <v-icon>mdi-view-dashboard-outline</v-icon>
    </v-btn>
    <v-btn
      v-if="$store.state.teacherAccess"
      to="/academy/dashboard"
    >
      <span>{{ $t('academyDashboard') }}</span>

      <v-icon>mdi-town-hall</v-icon>
    </v-btn>
    <v-btn
      to="/taskDesk"
    >
      <span>{{ $t('taskDesk') }}</span>

      <v-icon>mdi-file-tree</v-icon>
    </v-btn>
    <v-btn
      v-if="!$store.state.teacherAccess"
      to="/customer/list"
    >
      <span>{{ $t('accountList') }}</span>

      <v-icon>mdi-account-multiple-outline</v-icon>
    </v-btn>
    <v-btn
      v-if="!$store.state.teacherAccess"
      to="/sell/list"
    >
      <span>{{ ($store.state.shopSystem ? $t('orders') : $t('sell')) }}</span>

      <v-icon>mdi-shopping-outline</v-icon>
    </v-btn>

    <v-btn
      v-if="!$store.state.teacherAccess"
      to="/setting/index"
    >
      <span>{{ $t('setting') }}</span>

      <v-icon>mdi-cog-outline</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
  export default {
    name: 'DashboardCoreFooter',

    data: () => ({
      links: [
        // {
        //   href: '#',
        //   text: 'Creative Tim',
        // },
        // {
        //   href: '#',
        //   text: 'About Us',
        // },
        // {
        //   href: '#',
        //   text: 'Blog',
        // },
        // {
        //   href: '#',
        //   text: 'Licenses',
        // },
      ],
    }),
  }
</script>

<style lang="sass">
  #dashboard-core-footer
    a
      font-size: .825rem
      font-weight: 500
      text-decoration: none
      text-transform: uppercase
</style>

<style scoped>
.active-btn {
  color: #0066FF !important
}
</style>
